// src/components/PrivateRoute.js
import { useAuth } from '../utils/AuthContext';
import { Navigate } from 'react-router-dom';

const PrivateRoute = ({ children }) => {
  const { user, hasCheckedAuth } = useAuth();

  if (!hasCheckedAuth) return <div>Loading...</div>;

  return user ? children : <Navigate to="/login" />;
};

export default PrivateRoute;
